import { cn } from '../lib/utils'

const variants: Record<string, string> = {
  active: 'bg-utility-success text-accent-green',
  upcoming: 'bg-blue-100 text-blue-700',
  onboarding: 'bg-amber-100 text-amber-700',
  // Solid brand lime — the light tints are all taken, and a bright fill wants dark ink.
  quoting: 'bg-brand-600 text-ink-900',
  underwriting: 'bg-blue-100 text-blue-700',
  completed: 'bg-utility-success text-accent-green',
  deactivated: 'bg-red-100 text-red-700',
  canceling: 'bg-amber-100 text-amber-700',
  canceled: 'bg-red-100 text-red-700',
  expired: 'bg-red-100 text-red-700',
  inactive: 'bg-gray-100 text-gray-600',
  mql: 'bg-gray-100 text-gray-600',
  sql: 'bg-gray-100 text-gray-600',
}

const labels: Record<string, string> = {
  not_purchased: 'Not purchased',
  bookkeeping_paused: 'Paused',
  unknown: 'Unknown',
  mql: 'MQL',
  sql: 'SQL',
  active: 'Active',
  upcoming: 'Upcoming',
  onboarding: 'Onboarding',
  quoting: 'Quoting',
  underwriting: 'Underwriting',
  deactivated: 'Deactivated',
  inactive: 'Inactive',
}

function getVariant(status: string): string {
  return variants[status.toLowerCase()] ?? 'bg-gray-100 text-gray-600'
}

function getLabel(status: string): string {
  const key = status.toLowerCase()
  if (labels[key]) return labels[key]
  return status.replace(/[_-]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}

export function StatusPill({ status, className }: { status: string; className?: string }) {
  if (!status) return null

  return (
    <span
      className={cn('inline-block rounded-sm px-3 py-1 text-sm font-medium', getVariant(status), className)}
    >
      {getLabel(status)}
    </span>
  )
}
